import { render } from "./WorldMap.vue?vue&type=template&id=0ac00967"
import script from "./WorldMap.vue?vue&type=script&lang=js"
export * from "./WorldMap.vue?vue&type=script&lang=js"

import "./WorldMap.vue?vue&type=style&index=0&id=0ac00967&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__